import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideRouter, TitleStrategy, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatDialogModule } from '@angular/material/dialog';
import { GALLERY_CONFIG, GalleryConfig } from 'ng-gallery';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { GtmTitleStrategy } from './app/core/analytics/gtm.service';
import { ChunkLoadErrorHandler } from './core/app-version/chunk-load-error.handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideClientHydration(withEventReplay()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideAnimationsAsync(),
    provideHttpClient(withFetch()),
    importProvidersFrom(MatDialogModule),
    provideIonicAngular(),
    { provide: TitleStrategy, useClass: GtmTitleStrategy },
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    {
      provide: GALLERY_CONFIG,
      useValue: {
        autoHeight: true,
        imageSize: 'cover'
      } as GalleryConfig
    }
  ]
};
